import humanizeDuration from 'humanize-duration'
import AccurateTimeInterval from '@/utils/accurateTimeInterval.js'

const timerMixin = {
  data () {
    return {
      timer: null
    }
  },
  created () {
    this.timer = new AccurateTimeInterval()
  },
  // чистим установщик текущего времени и подключение
  beforeDestroy () {
    if (this.timer) {
      this.timer.stop()
      this.timer = null
    }
  },
  methods: {
    getHumanizedDurationString: function (duration) {
      let units
      if (duration < 59999) {
        units = ['s']
      } else if (duration < 3599999) {
        units = ['m', 's']
      } else {
        units = ['d', 'h', 'm']
      }

      return humanizeDuration(
        duration,
        {
          round: false,
          maxDecimalPoints: 0,
          units: units,
          language: this.systemLocale
        })
    }
  }
}

export default timerMixin
